export default __webpack_public_path__ + "static/media/memTeam3.65dd8355.png";